import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUnreadNotifications, doDismissNotification } from 'app/store/notifications';
import { NotificationHub } from './NotificationHub.jsx';

const mapStateToProps = createStructuredSelector({
    notifications: selectUnreadNotifications
});

const mapDispatchToProps = {
    onDismiss: doDismissNotification
};

export const NotificationHubContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationHub);
